/* eslint-disable */
import React, { useState, useContext, useEffect } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import CommonScrollBar from "../Common/CommonScrollBar";
import { MARKETING_CAMPAIGNS_URL } from "../Shared/constant";
import { Form, Spinner } from "react-bootstrap";
import CheckValid from "../Common/CheckValid";
import EmptySpaceFieldValid from "../Common/EmptySpaceFieldValid";
import UploadFileIcon from "../../assets/img/Upload-File.svg";
import DeleteIcon from "../../assets/img/remove_file.svg";
import UploadFileAPI from "../../Api/UploadFileAPI";
import { useSelector } from "react-redux";
import wsSend_request from "../../Api/ws/ws_request";
import { WebSocketContext } from "../../App";
import CommonToggle from "../Common/CommonToggle";
import DatePicker from "react-datepicker";
import CommonDateTime from "../Common/CommonDateTime";

const CreateMarketingCampaigns = () => {
  const today = new Date();
  const [LoaderImage, setLoaderImage] = useState(false);

  const { roomId } = useParams();
  const Navigate = useNavigate();
  const { websocket } = useContext(WebSocketContext);
  const CurrentLocation = useLocation().pathname.split("/")[1];
  const { accessToken, device_id, ClearFormSet, MarketCampaignsListing } =
    useSelector((state) => state.adminReducers);
    
  const CurrentData_ = MarketCampaignsListing?.list?.filter(
    (elm) => elm?.id === roomId
  )[0];

  const [NotificationState, setNotificationState] = useState({
    Title: "",
    StartDate: "",
    EndDate: "",
    Description: "",
    UploadedImage: "",
    UploadedImageName: "",
    Status: true,
  });
  const [LoaderFile, setLoaderFile] = useState({
    id: "",
    open: false,
  });
  const [CompaignsCategory, setCompaignsCategory] = useState([
    {
      id: 1,
      category_name: "Facebook Creatives",
      isChecked: false,
      UploadedImages: [],
    },
    {
      id: 2,
      category_name: "Instagram Creatives",
      isChecked: false,
      UploadedImages: [],
    },
    {
      id: 3,
      category_name: "WhatsApp Creatives",
      isChecked: false,
      UploadedImages: [],
    },
  ]);

  // ERROR STATES
  const [errorTitle, seterrorTitle] = useState("");
  const [errorDescription, seterrorDescription] = useState("");
  const [errorStartDate, seterrorStartDate] = useState("");
  const [errorEndDate, seterrorEndDate] = useState("");
  const [errorUploadedImage, seterrorUploadedImage] = useState("");
  const [CategoryImages, setCategoryImages] = useState("");

  useEffect(() => {
    if (CurrentLocation === "edit-marketing-campaigns") {
      setNotificationState({
        ...NotificationState,
        Title: CurrentData_?.card_title,
        Description: CurrentData_?.card_description,
        Status: CurrentData_?.status,
        StartDate: new Date(CurrentData_?.start_date),
        EndDate: new Date(CurrentData_?.end_date),
        UploadedImageName: CurrentData_?.image_name
      });

      const UpdateCompaignsCategory = CompaignsCategory?.map((elm) => {
        const matchedCategory = CurrentData_?.categories?.find(
          (elmz) => elmz?.category_name === elm?.category_name
        );
        if (matchedCategory) {
          return {
            ...elm,
            isChecked: true,
            UploadedImages: matchedCategory?.uploaded_files?.map((elmss) => ({
              id: elmss?.file?.split("/")[2],
              name: elmss?.file_name,
            })),
          };
        }
        return elm;
      });
      setCompaignsCategory(UpdateCompaignsCategory);
    }
  }, [CurrentData_]);

  // SELECT START DATE
  const DateStartGet = (date) => {
    if (date === null) {
      setNotificationState({
        ...NotificationState,
        StartDate: "",
        EndDate: "",
      });
      CheckValid(date === null || date === "" ? "" : date, {
        type: "NotificationStartDate",
        error: seterrorStartDate,
      });
    } else {
      setNotificationState({
        ...NotificationState,
        StartDate: date,
        EndDate: "",
      });
      CheckValid(date, {
        type: "NotificationStartDate",
        error: seterrorStartDate,
      });
    }
  };

  // SELECT END DATE
  const DateEndGet = (date) => {
    if (date === null) {
      setNotificationState({
        ...NotificationState,
        EndDate: "",
      });
      CheckValid(date === null ? "" : date, {
        type: "NotificationEndDate",
        error: seterrorEndDate,
      });
    } else {
      setNotificationState({
        ...NotificationState,
        EndDate: date,
      });
      CheckValid(date, { type: "NotificationEndDate", error: seterrorEndDate });
    }
  };

  // UPLOAD IMAGE FUNCTION
  const UploadImageCatgory = async (e, id) => {
    const files = e.target.files[0];
    if (files) {
      setLoaderFile({
        ...LoaderFile,
        id: id,
        open: true,
      });
      const formDatas = new FormData();
      formDatas.append("file", files, files.name);
      const fileresponse = await UploadFileAPI(accessToken, formDatas);
      if (fileresponse?.status === 200) {
        const fileObject = {
          id: fileresponse?.id,
          name: fileresponse?.name,
        };
        const UpdateCompaignsCategory = CompaignsCategory?.map((elm) => {
          if (elm?.id === id) {
            return {
              ...elm,
              UploadedImages: [...elm.UploadedImages, fileObject],
            };
          }
          return elm;
        });
        setCompaignsCategory(UpdateCompaignsCategory);
        setLoaderFile({
          ...LoaderFile,
          id: "",
          open: false,
        });
        setCategoryImages("");
        e.target.value = "";
      } else {
        setLoaderFile({
          ...LoaderFile,
          id: "",
          open: false,
        });
      }
    }
  };
  const UploadImage = async (e) => {
    const files = e.target.files[0];
    if (files) {
      setLoaderImage(true);
      const formDatas = new FormData();
      formDatas.append("file", files, files.name);
      const fileresponse = await UploadFileAPI(accessToken, formDatas);
      if (fileresponse?.status === 200) {
        setNotificationState({
          ...NotificationState,
          UploadedImage: fileresponse?.id,
          UploadedImageName: fileresponse?.name,
        });

        CheckValid(fileresponse, {
          type: "NotificationUploadedImage",
          error: seterrorUploadedImage,
        });

        setTimeout(() => {
          setLoaderFile(false);
        }, 1000);
        document.getElementById("fileInput").value = null;
      } else {
        setLoaderFile(false);
        setNotificationState({
          ...NotificationState,
          UploadedImage: "",
          UploadedImageName: "",
        });

        CheckValid("", {
          type: "NotificationUploadedImage",
          error: seterrorUploadedImage,
        });
      }
    }
  };

  // DELETE UPLOADED IMAGES
  const DeleteUploadedImage = (main_id, file_id) => {
    const UpdateCompaignsCategory = CompaignsCategory?.map((elm) => {
      if (elm?.id === main_id) {
        return {
          ...elm,
          UploadedImages: elm.UploadedImages?.map((elmx) => {
            if (elmx?.id !== file_id) {
              return elmx;
            }
          })?.filter((elz) => elz !== undefined),
        };
      }
      return elm;
    });
    setCompaignsCategory(UpdateCompaignsCategory);
  };

  // CREATE MARKET CAMPAIGNS FUNCTION
  const CheckUploadImageIsEmpty = CompaignsCategory?.every(
    (elm) => elm?.UploadedImages?.length === 0
  );

  const CreateNotificationsCMS = () => {
    if (
      NotificationState?.Title !== "" &&
      NotificationState?.Description !== "" &&
      !CheckUploadImageIsEmpty
    ) {
      setCategoryImages("");

      const UpdateCategory = CompaignsCategory?.filter(
        (elm) => elm?.UploadedImages?.length > 0 && elm?.isChecked
      ).map((elm) => ({
        category_name: elm?.category_name,
        uploaded_files: elm?.UploadedImages?.map((elm) => elm?.id)?.toString(),
      }));

      let param = {
        transmit: "broadcast",
        url:
          CurrentLocation === "edit-marketing-campaigns"
            ? "update_marketing_campaign"
            : "add_marketing_campaign",
        request: {
          card_title: NotificationState?.Title,
          card_description: NotificationState?.Description,
          status: NotificationState?.Status,
          category: UpdateCategory,
          start_date: CommonDateTime(
            NotificationState?.StartDate,
            "YYYY-MM-DD",
            "hide"
          ),
          end_date: CommonDateTime(
            NotificationState?.EndDate,
            "YYYY-MM-DD",
            "hide"
          ),
          image: NotificationState?.UploadedImage,
        },
        DeviceId: device_id,
      };

      if (CurrentLocation === "edit-marketing-campaigns") {
        param.request.campaign_id = roomId;
      }

      wsSend_request(websocket, param);
    } else {
      CheckValid(NotificationState?.Title, {
        type: "CampaignTitle",
        error: seterrorTitle,
      });
      CheckValid(NotificationState?.Description, {
        type: "CampaignDescription",
        error: seterrorDescription,
      });

      if (CheckUploadImageIsEmpty) {
        setCategoryImages("Category-wise images should not be empty.");
      }
    }
  };

  useEffect(() => {
    if (
      ClearFormSet?.action === 200 &&
      (ClearFormSet?.url === "add_marketing_campaign" ||
        ClearFormSet?.url === "update_marketing_campaign")
    ) {
      Navigate(MARKETING_CAMPAIGNS_URL);
    }
  }, [ClearFormSet]);

  return (
    <section className="createApplcation_wrapper">
      <div className="MainHeader">
        <h4>
          {CurrentLocation === "edit-marketing-campaigns" ? "Edit" : "Create"}{" "}
          Campaign
        </h4>
        <Link to={MARKETING_CAMPAIGNS_URL} className="btn btn-link backbtn">
          <i className="bi bi-arrow-left-short"></i> Back
        </Link>
      </div>
      <div className="tabsWrappersmAN">
        <CommonScrollBar
          className="ScrollbarsSidebar"
          height={{ height: "calc(100vh - 135px)" }}
        >
          <div className="formloginset mb-3">
            <div className="row">
              <div className="col-md-3">
                <Form.Group className="mb-3">
                  <Form.Label>
                    Card Title<span className="mendatory_star">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={NotificationState?.Title}
                    onChange={(e) =>
                      setNotificationState({
                        ...NotificationState,
                        Title: e.target.value,
                      })
                    }
                    onKeyUp={(e) =>
                      CheckValid(e.target.value, {
                        type: "CampaignTitle",
                        error: seterrorTitle,
                      })
                    }
                    onKeyDown={EmptySpaceFieldValid}
                    placeholder="Enter Card Title"
                  />
                  {errorTitle !== "" && (
                    <span className="error_medotory">{errorTitle}</span>
                  )}
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Form.Label>
                    Card Description<span className="mendatory_star">*</span>
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={NotificationState?.Description}
                    onChange={(e) =>
                      setNotificationState({
                        ...NotificationState,
                        Description: e.target.value,
                      })
                    }
                    onKeyUp={(e) =>
                      CheckValid(e.target.value, {
                        type: "CampaignDescription",
                        error: seterrorDescription,
                      })
                    }
                    onKeyDown={EmptySpaceFieldValid}
                    placeholder="Enter Card Description"
                  />
                  {errorDescription !== "" && (
                    <span className="error_medotory">{errorDescription}</span>
                  )}
                </Form.Group>
              </div>
              <div className="col-md-3">
                <CommonToggle
                  isBadgeAllow={true}
                  badgeTitle={"active_inactive"}
                  valueToggle={NotificationState?.Status}
                  setValueToggle={(e) =>
                    setNotificationState({
                      ...NotificationState,
                      Status: !NotificationState?.Status,
                    })
                  }
                  name={"Status"}
                />
              </div>
            </div>
          </div>
          <div
            className="formloginset mb-3"
            style={{
              borderBottom: "0px",
            }}
          >
            <div className="row">
              <div className="col-md-3">
                <Form.Group className="mb-3">
                  <Form.Label>
                    Start Date<span className="mendatory_star">*</span>
                  </Form.Label>
                  <div className="datepickField min">
                    <DatePicker
                      selected={NotificationState?.StartDate}
                      onChange={(date) => DateStartGet(date)}
                      dateFormat="dd/MM/yyyy"
                      minDate={today}
                      placeholderText="Enter Start Date"
                      isClearable={NotificationState?.StartDate ? true : false}
                      autoComplete="off"
                    />
                  </div>
                  {errorStartDate && (
                    <small className="error_medotory">{errorStartDate}</small>
                  )}
                </Form.Group>
              </div>
              <div className="col-md-3">
                <Form.Group className="mb-3">
                  <Form.Label>
                    End Date<span className="mendatory_star">*</span>
                  </Form.Label>
                  <div className="datepickField">
                    <DatePicker
                      minDate={NotificationState?.StartDate}
                      selected={NotificationState?.EndDate}
                      onChange={(date) => DateEndGet(date)}
                      dateFormat="dd/MM/yyyy"
                      placeholderText="Enter End Date"
                      isClearable={NotificationState?.EndDate ? true : false}
                      name="ToDate"
                      autoComplete="off"
                    />
                  </div>
                  {errorEndDate && (
                    <small className="error_medotory">{errorEndDate}</small>
                  )}
                </Form.Group>
              </div>
              <div className="col-md-3">
                <Form.Group className="mb-3">
                  <Form.Label>Upload Image</Form.Label>
                  {NotificationState?.UploadedImageName === "" ? (
                    <div className="uploaded_image">
                      <label className="btn" id="upload_image_btn">
                        <input
                          type="file"
                          name="upload"
                          id="fileInput"
                          onChange={(e) => UploadImage(e)}
                          accept=".jpg, .jpeg, .png"
                        />
                        <img src={UploadFileIcon} alt="Upload" />
                        Upload Image
                      </label>
                      {LoaderImage && <Spinner />}
                    </div>
                  ) : (
                    <div className="image_upload_notifications_cmn">
                      {NotificationState?.UploadedImageName}
                      <img
                        src={DeleteIcon}
                        className="delete_btn"
                        onClick={() => {
                          setNotificationState({
                            ...NotificationState,
                            UploadedImage: "",
                            UploadedImageName: "",
                          });
                          CheckValid("", {
                            type: "NotificationUploadedImage",
                            error: seterrorUploadedImage,
                          });
                        }}
                        alt="edit"
                      />
                    </div>
                  )}
                  {errorUploadedImage && (
                    <small className="error_medotory">
                      {errorUploadedImage}
                    </small>
                  )}
                </Form.Group>
              </div>
            </div>
          </div>
          <div
            className="divider_forms"
            style={{
              borderBottom: "0px",
              paddingBottom: "0px",
              marginBottom: "0px",
            }}
          >
            <Form.Group className="mb-3">
              <Form.Label>
                Category<span className="mendatory_star">*</span>
              </Form.Label>
              <div className="custome_radio_button_wraps category_marketing_campaigns">
                {CompaignsCategory?.map((elm, index) => {
                  return (
                    <div
                      key={index}
                      className="col-md-12 custom_frequency_days"
                    >
                      <div className="form-group form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={index}
                          checked={elm.isChecked}
                          onChange={(e) => {
                            const updatedFrequency = CompaignsCategory.map(
                              (freq) =>
                                freq.id === elm.id
                                  ? {
                                      ...freq,
                                      isChecked: e.target.checked,
                                    }
                                  : freq
                            );
                            setCompaignsCategory(updatedFrequency);
                          }}
                        />
                        <label className="form-check-label" htmlFor={index}>
                          {elm?.category_name}
                        </label>
                      </div>
                      {elm.isChecked && (
                        <div className="col-md-3" style={{ width: "100%" }}>
                          <Form.Group
                            className="mb-3"
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              columnGap: "10px",
                              rowGap: "5px",
                            }}
                          >
                            <div className="uploaded_image">
                              <label
                                className="btn"
                                id="upload_image_btn"
                                disabled={
                                  LoaderFile?.id === elm?.id && LoaderFile?.open
                                }
                              >
                                <input
                                  type="file"
                                  name="upload"
                                  id="fileInput"
                                  onChange={(e) =>
                                    UploadImageCatgory(e, elm?.id)
                                  }
                                  accept=".jpg, .jpeg, .png"
                                  disabled={
                                    LoaderFile?.id === elm?.id &&
                                    LoaderFile?.open
                                  }
                                />
                                {LoaderFile?.id === elm?.id &&
                                LoaderFile?.open ? (
                                  <Spinner />
                                ) : (
                                  <img src={UploadFileIcon} alt="Upload" />
                                )}
                                Upload Image
                              </label>
                            </div>
                            {elm?.UploadedImages?.map((files, index) => {
                              return (
                                <div
                                  className="image_upload_notifications_cmn"
                                  key={index}
                                >
                                  {files?.name}
                                  <img
                                    src={DeleteIcon}
                                    className="delete_btn"
                                    onClick={() =>
                                      DeleteUploadedImage(elm?.id, files?.id)
                                    }
                                    alt="edit"
                                  />
                                </div>
                              );
                            })}
                          </Form.Group>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
              {CategoryImages !== "" && (
                <span className="error_medotory">{CategoryImages}</span>
              )}
            </Form.Group>
            <button
              className="btn formbtn"
              style={{ width: "auto" }}
              onClick={() => CreateNotificationsCMS()}
              variant="primary"
              disabled={
                ClearFormSet?.action === 200 &&
                (ClearFormSet?.url === "add_marketing_campaign" ||
                  ClearFormSet?.url === "update_marketing_campaign")
              }
            >
              Submit
            </button>
          </div>
        </CommonScrollBar>
      </div>
    </section>
  );
};

export default CreateMarketingCampaigns;
